//@flow
import * as React from 'react';
import styles from './AttributeList.scss';

export type AttributeListItem =
  | string
  | {
      key: string,
      label: string,
      value: ?React.Element<any> | Array<React.Element<any> | string>,
    };

type Props = {
  items: AttributeListItem[],
  className?: string,
};

const AttributeList = (props: Props) => {
  return (
    <table className={`${styles.attributeList} ${props.className || ''}`}>
      <tbody>
        {props.items.map(item => {
          if (typeof item === 'string') {
            return (
              <tr key={item}>
                <td colSpan="2">
                  <div className={styles.attributeListDivider}>
                    <span
                      className={styles.attributeListDividerLabel}
                      data-translate={true}
                    >
                      {item}
                    </span>
                  </div>
                </td>
              </tr>
            );
          }

          const { key, label, value } = item;

          return (
            <tr key={key}>
              <td className={styles.attributeListName} data-translate={true}>
                {label}
              </td>
              <td className={styles.attributeListValue} data-key={key}>
                {value}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default AttributeList;



// WEBPACK FOOTER //
// ./src/components/ContentSection/AttributeList.js